import { DataDomainPermission } from '../types/DataDomainPermission';
import {
  DataDomainPermissionDetails,
  UserDetailsFormModel,
  UserDetailsViewModel,
} from '../types/UserDetailsViewModel';
import { formatSchoolForDisplay } from '../utilities/textUtilities';

export const mapToFormModel = (
  details: UserDetailsViewModel
): UserDetailsFormModel => {
  const dataDomainPermissions: DataDomainPermissionDetails[] = [];

  const getAdditionalPermissions = (
    permission: DataDomainPermission
  ): string => {
    const items: string[] = [];
    if (permission.canCertifyDistrict) {
      items.push('Can Certify District');
    }
    if (permission.canCertifySchools) {
      items.push('Can Certify Schools');
    }
    if (permission.msisIdRequestAccess) {
      items.push('MSIS ID Request');
    }
    if (permission.salaryAccess) {
      items.push('Salary');
    }
    if (permission.studentOwnershipAccess) {
      items.push('Student Ownership');
    }
    if (permission.updateGradesAccess) {
      items.push('Update Grades');
    }
    if (permission.dyslexiaScreenerAccess) {
      items.push('Dyslexia Screener');
    }
    if (permission.literacyScreenerAccess) {
      items.push('Literacy Screener');
    }
    if (permission.exitAdjustmentsAccess) {
      items.push('Exit Adjustments');
    }
    return items.join(', ');
  };

  for (const [key, value] of Object.entries(
    details.permissionsByDataDomainForViewingDistrict
  )) {
    const schoolList = value.schools
      .map((school) => formatSchoolForDisplay(school))
      .join(', ');
    dataDomainPermissions.push({
      role: key,
      schools: schoolList,
      additionalPermissions: getAdditionalPermissions(value),
    });
  }

  return {
    ...details,
    dataDomainPermissionsForViewingDistrict: dataDomainPermissions,
  };
};
